import settingIds from './setting-ids';

export default {
  IMAGE: `${settingIds.THIS_MEDIA}-image`,
  IFRAME: `${settingIds.THIS_MEDIA}-iframe`,
  LINK: `${settingIds.THIS_MEDIA}-link`,
};
